'use strict';

var Animations = {
  moneyValue: function moneyValue(startValue, endValue, dollarsElement, centsElement, excludeCurrency) {
    if (dollarsElement instanceof jQuery && dollarsElement.length) {
      var displayStep = function displayStep(value) {
        if (centsElement instanceof jQuery && centsElement.length) {
          var money = Formatters.formatMoney(value, { noCurrencySymbol: excludeCurrency }).split('.');
          dollarsElement.text(money[0]);
          centsElement.text('.' + money[1]);
        } else {
          dollarsElement.text(Formatters.formatMoney(Math.ceil(value), {
            optionalDecimals: true,
            noCurrencySymbol: excludeCurrency
          }));
        }
      };

      startValue = startValue || 0;
      endValue = endValue || 0;

      $({ value: startValue }).animate({ value: endValue }, {
        duration: 1000,
        easing: 'easeInExpo',
        step: function step() {
          displayStep(this.value);
        },
        complete: function complete() {
          displayStep(endValue);
        }
      });
    }
  },
  integerValue: function integerValue(startValue, endValue, element) {
    Animations.moneyValue(startValue, endValue, element, null, true);
  }
};